import { Link } from "react-router-dom";
import type { Service } from "@/types";

interface ServiceCardProps {
  service: Service;
  index?: number;
}

export default function ServiceCard({ service, index = 0 }: ServiceCardProps) {
  return (
    <article
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 animate-fade-up"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-100">
        <img
          src={service.imagen_url}
          alt={`Servicio de ${service.titulo} de AXONIA GROUP`}
          title={`${service.titulo} — AXONIA GROUP`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50/95 text-primary-600 backdrop-blur-sm">
          <i className={`${service.icono} text-xl leading-none`} aria-hidden="true"></i>
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-950 md:text-lg">
          {service.titulo}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {service.descripcion}
        </p>
        <Link
          to="/solicitar-servicio"
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-semibold text-primary-600 transition-colors duration-200 hover:text-primary-700"
        >
          Solicitar servicio
          <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
        </Link>
      </div>
    </article>
  );
}